import { clickOutside } from '~/directives/click-outside/click-outside-directive';

export default defineNuxtPlugin((nuxtApp) => {

  // Register global directives
  nuxtApp.vueApp.directive('click-outside', clickOutside);

});
